<template>
  <div>
    <confirmation-dialog
      hide-open-button
      message-title="REMOVER TIPO DE HOSPEDAGEM"
      message-body="TEM CERTEZA QUE DESEJA REMOVER O TIPO DE HOSPEDAGEM?"
      @yes="evOnRemoveTypeOfHostingAccepted"
      v-model="showRemoveTypeOfHosting"
    />

    <view-value
      :type_of_hosting_value="type_of_hosting_value"
      @close="type_of_hosting_value = null"
      @updated="getValues"
    />

    <b-modal
      id="finance_configuration_category"
      title="ALTERAR CATEGORIA DO FINANCEIRO"
      no-close-on-backdrop
      hide-footer
    >
      <finance-configuration-category
        :category_id="category_id"
        :hosting_type_value_id="hosting_type_value_id"
        :finance_configuration_category="finance_configuration_category"
        @success="getValues"
      />
    </b-modal>

    <bonded-residents :residents="residents" />

    <b-modal
      no-close-on-backdrop
      size="xl"
      id="view_type_of_hosting"
      hide-footer
      title="EDITAR TIPO DE HOSPEDAGEM"
      @show="evOnShow"
      @shown="evOnShown"
      @hide="evOnHide"
    >
      <b-form @submit.prevent="evOnSubmit">
        <div class="row m-0">
          <div class="col-md-12 v-clean">
            <h1 class="title-pages">INFORMAÇÕES</h1>
            <div class="row">
              <div class="col-md-6">
                <label-required-field label="Tipo de cobrança" />
                <b-select
                  :disabled="!permission('edit', 'type_of_hosting')"
                  v-model="billing_type_of_hosting_type_id"
                >
                  <b-select-option
                    v-for="value in billing_type_of_hosting_types"
                    :key="value.id"
                    :value="value.id"
                  >
                    {{ value.name }}
                  </b-select-option>
                </b-select>
              </div>
              <div class="col-md-6">
                <label-required-field label="Nome" />
                <b-input
                  :disabled="!permission('edit', 'type_of_hosting')"
                  type="text"
                  ref="name"
                  v-model="name"
                />
              </div>
              <div class="col-md-12">
                <v-btn
                  v-if="permission('edit', 'type_of_hosting')"
                  :disabled="loading"
                  type="submit"
                  class="btn-save ml-2 float-right"
                >
                  <i class="fas fa-save mr-2 text-twenty"></i>
                  {{ loading ? "Carregando" : "SALVAR" }}
                </v-btn>
              </div>
            </div>
          </div>
          <div class="col-md-12 v-clean mt-2">
            <div class="row">
              <div
                class="col-md-12"
                v-if="permission('edit', 'type_of_hosting')"
              >
                <h1 class="title-pages">ADICIONAR VALORES</h1>
                <b-form @submit.prevent="createHostingTypeValue">
                  <b-row align-v="end">
                    <b-col>
                      <label-required-field label="Valor" />
                      <b-input
                        type="text"
                        ref="value"
                        v-model="value"
                        @keyup="handleValue"
                      />
                    </b-col>
                    <b-col>
                      <label>Descrição</label>
                      <b-input type="text" v-model="description" />
                    </b-col>
                    <b-col cols="auto">
                      <v-btn :disabled="loading" type="submit" class="btn-add">
                        <i class="fas fa-plus mr-2 text-twenty"></i>
                        {{ loading ? "Carregando" : "ADICIONAR" }}
                      </v-btn>
                    </b-col>
                  </b-row>
                </b-form>
              </div>
              <div class="col-md-12">
                <h1 class="title-pages">VALORES</h1>
                <div
                  class="v-clean p-5 text-center"
                  v-show="hostingTypeValue.length == 0"
                >
                  <h6 class="text-center upper-text worksansr">
                    SEM RESULTADOS!
                  </h6>
                </div>
                <v-data-table
                  v-show="hostingTypeValue.length > 0"
                  dense
                  :headers="headers"
                  :items="hostingTypeValue"
                  :footer-props="{
                    'items-per-page-options': [50, 75, 100],
                    'items-per-page-text': 'Mostrar',
                  }"
                >
                  <template v-slot:[`item.value`]="{ item }">
                    {{ formatPrice(item.value) }}
                  </template>
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-btn
                      small
                      @click="type_of_hosting_value = item"
                      class="btn-edit m-1"
                    >
                      <i class="fas fa-pen mr-2 text-twenty"></i>
                      EDITAR
                    </v-btn>
                    <v-btn
                      v-if="permission('read', 'financial')"
                      small
                      @click="handleModalFinance(item)"
                      class="btn-i m-1"
                    >
                      <i class="fas fa-edit mr-2 text-twenty"></i>
                      ALTERAR CATEGORIA DO FINANCEIRO
                    </v-btn>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <warning-message
              v-if="!permission('edit', 'type_of_hosting')"
              message="Você não tem permissão para modificar tipos de hospedagens"
            />
            <warning-required-fields
              v-if="permission('edit', 'type_of_hosting')"
            />
            <errors-messages :errors="errors" />
          </div>
          <div class="col-md-12">
            <h6 v-if="type_of_hosting" class="mb-0 worksansr">
              Criação:
              {{ formatDate(type_of_hosting.created_at) }}
            </h6>
            <h6 v-if="type_of_hosting" class="mb-0 worksansr">
              Última alteração:
              {{ formatDate(type_of_hosting.updated_at) }}
            </h6>
          </div>
        </div>
        <b-row>
          <b-col>
            <v-btn
              class="btn-cancel"
              @click="$bvModal.hide('view_type_of_hosting')"
            >
              <i class="fas fa-times mr-2 text-twenty"></i>
              CANCELAR
            </v-btn>
          </b-col>
          <b-col cols="auto">
            <v-btn
              v-if="permission('remove', 'type_of_hosting')"
              class="btn-delete ml-2"
              @click="showRemoveTypeOfHosting = true"
            >
              <i class="fas fa-trash mr-2 text-twenty"></i> EXCLUIR TIPO DE
              HOSPEDAGEM
            </v-btn>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import LabelRequiredField from "../Components/LabelRequiredField.vue";
import WarningMessage from "../Components/WarningMessage.vue";
import WarningRequiredFields from "../Components/WarningRequiredFields.vue";
import ErrorsMessages from "../Components/ErrorsMessages.vue";
import ConfirmationDialog from "../Components/ConfirmationDialog.vue";
import ViewValue from "./view-value.vue";
import BondedResidents from "./bonded-residents.vue";
import FinanceConfigurationCategory from "./finance-configuration-category.vue";

import api from "../../services/api";

import toast from "../../lib/ToastNotification";

import { formatDate, formatValueOnKeyUp, formatPrice } from "../../lib/format";

import permission from "../../lib/permission";

export default {
  name: "ViewTypeOfHosting",

  components: {
    LabelRequiredField,
    WarningMessage,
    WarningRequiredFields,
    ErrorsMessages,
    ConfirmationDialog,
    ViewValue,
    BondedResidents,
    FinanceConfigurationCategory,
  },

  props: {
    type_of_hosting: Object,
    finance_configuration_category: Array,
  },

  data() {
    return {
      errors: [],
      loading: false,

      showRemoveTypeOfHosting: false,

      billing_type_of_hosting_types: [],
      billing_type_of_hosting_type_id: "",
      hosting_type_value_id: "",
      category_id: "",
      name: "",

      value: "",
      description: "",
      headers: [
        { text: "VALOR", value: "value" },
        { text: "DESCRIÇÃO", value: "description" },
        { text: "AÇÕES", value: "actions" },
      ],
      hostingTypeValue: [],

      type_of_hosting_value: null,

      residents: [],
    };
  },

  watch: {
    type_of_hosting() {
      if (!this.type_of_hosting) return;

      this.$bvModal.show("view_type_of_hosting");
    },
  },

  created() {
    this.evOnCreated();
  },

  methods: {
    permission,
    formatDate,
    formatPrice,

    handleModalFinance(item) {
      this.hosting_type_value_id = item.id;
      this.category_id = item.finance_configuration_category_id;
      this.$bvModal.show("finance_configuration_category");
    },

    async evOnCreated() {
      if (permission("read", "financial")) {
        this.headers.splice(2, 0, {
          text: "CATEGORIA DO FINANCEIRO",
          value: "finance_configuration_category_name",
        });
      }
      await this.getBillingTypeOfHostingTypes();
    },

    async evOnShow() {
      this.errors = [];
      this.loading = false;

      this.showRemoveTypeOfHosting = false;

      this.billing_type_of_hosting_type_id =
        this.type_of_hosting.billing_type_of_hosting_type_id;
      this.name = this.type_of_hosting.name;

      this.value = "";
      this.description = "";

      this.type_of_hosting_value = null;

      this.getValues().then();
    },

    async evOnShown() {
      this.$refs.name.focus();
    },

    async evOnHide() {
      this.$emit("close");
    },

    async evOnRemoveTypeOfHostingAccepted() {
      try {
        this.loading = true;

        const data = { id: this.type_of_hosting.id };
        const response = await api.delete("/rest-home/type-of-hosting/delete", {
          data,
        });
        const { error, errors, message, residents } = response.data;

        if (error) {
          this.errors = errors;

          if (residents.length > 0) {
            this.residents = residents;
            this.$bvModal.show("bonded_residents");
          }
        } else {
          toast(message, "success");
          this.$bvModal.hide("view_type_of_hosting");
          this.$emit("updated");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getValues() {
      try {
        this.loading = true;

        const params = { type_of_hosting_id: this.type_of_hosting.id };
        const response = await api.get("/rest-home/hosting-type-value/all", {
          params,
        });
        const { error, errors, hosting_type_value } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.hostingTypeValue = hosting_type_value;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    handleValue: function (e) {
      this.value = formatValueOnKeyUp(e.target.value);
    },

    async evOnSubmit() {
      try {
        this.loading = true;

        const data = {
          id: this.type_of_hosting.id,
          billing_type_of_hosting_type_id: this.billing_type_of_hosting_type_id,
          name: this.name,
        };
        const response = await api.put(
          "/rest-home/type-of-hosting/update",
          data
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          toast(message, "success");
          this.$bvModal.hide("view_type_of_hosting");
          this.$emit("updated");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async createHostingTypeValue() {
      try {
        this.loading = true;

        const data = {
          type_of_hosting_id: this.type_of_hosting.id,
          value: this.value,
          description: this.description,
        };
        const response = await api.post(
          "/rest-home/hosting-type-value/create",
          data
        );
        const { error, errors, message } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.value = "";
          this.description = "";
          this.$refs.value.focus();
          await this.getValues();
          toast(message, "success");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async getBillingTypeOfHostingTypes() {
      try {
        this.loading = true;

        const response = await api.get("/rest-home/type-of-hosting/types");
        const { error, errors, types } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.billing_type_of_hosting_types = types;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>